/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Admin_Space_Profile_Map_Map_LabelInputs */

const en_admin_space_profile_map_map_label = /** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Location of ${i?.name}`)
};

const de_admin_space_profile_map_map_label = /** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standort von ${i?.name}`)
};

const es_admin_space_profile_map_map_label = /** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ubicación de ${i?.name}`)
};

const fr_admin_space_profile_map_map_label = /** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Emplacement de ${i?.name}`)
};

const nl_admin_space_profile_map_map_label = /** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Locatie van ${i?.name}`)
};

/** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */
const it_admin_space_profile_map_map_label = en_admin_space_profile_map_map_label;

/** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */
const pt_br2_admin_space_profile_map_map_label = en_admin_space_profile_map_map_label;

/** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */
const pl_admin_space_profile_map_map_label = en_admin_space_profile_map_map_label;

/** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */
const hu_admin_space_profile_map_map_label = en_admin_space_profile_map_map_label;

/** @type {(inputs: Admin_Space_Profile_Map_Map_LabelInputs) => LocalizedString} */
const ro_admin_space_profile_map_map_label = en_admin_space_profile_map_map_label;

/**
* | output |
* | --- |
* | "Location of {name}" |
*
* @param {Admin_Space_Profile_Map_Map_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_space_profile_map_map_label = /** @type {((inputs: Admin_Space_Profile_Map_Map_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Space_Profile_Map_Map_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_space_profile_map_map_label(inputs)
	if (locale === "de") return de_admin_space_profile_map_map_label(inputs)
	if (locale === "es") return es_admin_space_profile_map_map_label(inputs)
	if (locale === "fr") return fr_admin_space_profile_map_map_label(inputs)
	if (locale === "nl") return nl_admin_space_profile_map_map_label(inputs)
	if (locale === "it") return it_admin_space_profile_map_map_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_space_profile_map_map_label(inputs)
	if (locale === "pl") return pl_admin_space_profile_map_map_label(inputs)
	if (locale === "hu") return hu_admin_space_profile_map_map_label(inputs)
	return ro_admin_space_profile_map_map_label(inputs)
});
export { admin_space_profile_map_map_label as "admin.space_profile_map.map_label" }